var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardHero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 574 306",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke-width: 1.5px;\n      }\n\n      .cls-2, .cls-10, .cls-3, .cls-5, .cls-11, .cls-6, .cls-7, .cls-8, .cls-9 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-7 {\n        stroke: #8ac4ff;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-13 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-14 {\n        fill: #012ad6;\n      }\n\n      .cls-15 {\n        fill: #0540ff;\n      }\n\n      .cls-16 {\n        fill: #ebecf0;\n      }\n\n      .cls-17, .cls-11, .cls-18 {\n        fill: #fff;\n      }\n\n      .cls-19, .cls-20, .cls-21 {\n        fill: #eceef1;\n      }\n\n      .cls-22 {\n        fill: #e4f2ff;\n      }\n\n      .cls-23, .cls-24 {\n        fill: #8ac4ff;\n      }\n\n      .cls-25, .cls-10 {\n        fill: #a6d2ff;\n      }\n\n      .cls-26 {\n        fill: #ccd0d5;\n      }\n\n      .cls-27 {\n        fill: #acb2b6;\n      }\n\n      .cls-28 {\n        fill: #101113;\n      }\n\n      .cls-29 {\n        fill: #3f4449;\n      }\n\n      .cls-30 {\n        fill: #3cdbd9;\n      }\n\n      .cls-31 {\n        fill: #2976ff;\n      }\n\n      .cls-32 {\n        fill: #3770ff;\n      }\n\n      .cls-33 {\n        fill: #3d4145;\n      }\n\n      .cls-34, .cls-35 {\n        fill: #5ca1ff;\n      }\n\n      .cls-36 {\n        fill: #80b9ff;\n      }\n\n      .cls-37 {\n        fill: #25cec8;\n      }\n\n      .cls-38 {\n        fill: #282c2e;\n      }\n\n      .cls-10 {\n        opacity: .53;\n      }\n\n      .cls-10, .cls-4, .cls-6 {\n        stroke: #0540ff;\n      }\n\n      .cls-3 {\n        stroke: #fff;\n        stroke-width: .66px;\n      }\n\n      .cls-39 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-39, .cls-40, .cls-41, .cls-42, .cls-43 {\n        opacity: .37;\n      }\n\n      .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46 {\n        mix-blend-mode: screen;\n      }\n\n      .cls-40 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-41 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-42 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-4 {\n        stroke-miterlimit: 6;\n      }\n\n      .cls-4, .cls-5, .cls-11 {\n        stroke-linecap: round;\n      }\n\n      .cls-5, .cls-9 {\n        stroke: #5ca1ff;\n      }\n\n      .cls-11 {\n        stroke: #cacfd4;\n      }\n\n      .cls-47 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-43 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-48 {\n        fill: #168f89;\n        opacity: .4;\n      }\n\n      .cls-48, .cls-49 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-44 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-44, .cls-45, .cls-46, .cls-20, .cls-50 {\n        opacity: .2;\n      }\n\n      .cls-45 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-46, .cls-51 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-52 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-53 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-54 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-55 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-8 {\n        stroke: #2976ff;\n      }\n\n      .cls-56, .cls-18 {\n        opacity: .6;\n      }\n\n      .cls-57 {\n        opacity: .8;\n      }\n\n      .cls-58, .cls-21 {\n        opacity: .7;\n      }\n\n      .cls-24 {\n        fill-rule: evenodd;\n      }\n\n      .cls-59 {\n        isolation: isolate;\n      }\n\n      .cls-49 {\n        opacity: .46;\n      }\n\n      .cls-35 {\n        opacity: .5;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 154.3,
    cy: 131.34,
    r: 75.34
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M386,40.42c0,33.69-27.31,61-61,61s-61-27.31-61-61S290.31,2,324,2s62,4.73,62,38.42Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 291.47,
    y1: 33,
    x2: 359.5,
    y2: 33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2783e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#269add"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#25b1d4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#25c1cd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#25cac9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25cec8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 291.47,
    y1: 32.95,
    x2: 359.5,
    y2: 32.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25cec8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#25bed1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#2797e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2975ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    y1: 51,
    y2: 51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 50.95,
    y2: 50.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 69,
    y2: 69,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 68.95,
    y2: 68.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 87,
    y2: 87,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    y1: 86.95,
    y2: 86.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    y1: 105,
    y2: 105,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    y1: 104.95,
    y2: 104.95,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 240.57,
    y1: 276.36,
    x2: 311.5,
    y2: 205.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#2a7fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#2989f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#27a7e2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#26bcd3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#25c9cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#25cec8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 361.99,
    y1: 165.68,
    x2: 445.15,
    y2: 284.45,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c3e4ff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 412.14,
    y1: 140.19,
    x2: 515.98,
    y2: 288.51,
    xlinkHref: "#linear-gradient-12"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mesh"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M201.85,61.14c-.4-.37-.43-1-.06-1.41h0c.37-.41,1.01-.44,1.41-.06h0c.41,.37,.44,1,.07,1.41h0c-.2,.21-.47,.32-.74,.32h0c-.24,0-.48-.08-.68-.26Zm4.8-5.09c-.39-.39-.39-1.03,0-1.42h0c.39-.39,1.02-.39,1.41,0h0c.39,.39,.4,1.02,0,1.41h0c-.2,.2-.45,.3-.71,.3h0c-.26,0-.51-.1-.71-.29Zm5.01-4.9c-.38-.4-.36-1.04,.05-1.41h0c.4-.38,1.04-.35,1.41,.05h0c.38,.41,.36,1.04-.05,1.41h0c-.19,.18-.44,.27-.68,.27h0c-.27,0-.54-.11-.73-.32Zm5.2-4.68c-.36-.42-.31-1.06,.11-1.41h0c.42-.36,1.05-.31,1.41,.11h0c.36,.42,.31,1.05-.11,1.41h0c-.19,.16-.42,.24-.65,.24h0c-.29,0-.57-.12-.76-.35Zm5.38-4.47c-.34-.44-.26-1.06,.17-1.41h0c.44-.34,1.07-.26,1.41,.17h0c.34,.44,.26,1.06-.17,1.41h0c-.19,.14-.4,.21-.62,.21h0c-.3,0-.59-.13-.79-.38Zm5.57-4.25c-.32-.44-.22-1.07,.22-1.39h0c.45-.32,1.08-.22,1.4,.22h0c.32,.45,.22,1.08-.23,1.4h.01c-.18,.13-.39,.19-.59,.19h0c-.31,0-.62-.15-.81-.42Zm5.73-4.01c-.3-.46-.17-1.08,.29-1.39h0c.46-.3,1.08-.17,1.38,.29h0c.31,.46,.18,1.08-.28,1.38h0c-.17,.12-.36,.17-.55,.17h0c-.33,0-.64-.16-.84-.45Zm5.9-3.77c-.29-.47-.14-1.09,.34-1.38h0c.47-.28,1.08-.13,1.37,.34h0c.29,.48,.13,1.09-.34,1.38h0c-.16,.1-.34,.14-.51,.14h0c-.34,0-.67-.17-.86-.48Zm6.04-3.53c-.26-.48-.09-1.09,.4-1.36h0c.48-.26,1.09-.09,1.36,.4h0c.26,.48,.09,1.09-.4,1.36h0c-.15,.08-.32,.12-.48,.12h0c-.35,0-.7-.19-.88-.52Zm6.19-3.27c-.25-.5-.05-1.1,.45-1.34h0c.49-.25,1.09-.05,1.34,.45h0c.24,.49,.04,1.09-.45,1.34h0c-.15,.07-.3,.1-.45,.1h0c-.36,0-.72-.2-.89-.55Zm6.31-3.02c-.22-.51,0-1.1,.51-1.32h0c.5-.23,1.09,0,1.32,.51h0c.22,.5,0,1.09-.51,1.31h0c-.13,.06-.27,.09-.4,.09h0c-.39,0-.75-.22-.92-.59Zm6.44-2.75c-.21-.52,.04-1.1,.56-1.3h0c.51-.2,1.09,.05,1.29,.56h0c.21,.51-.04,1.09-.55,1.3h0c-.13,.05-.25,.07-.37,.07h0c-.4,0-.78-.24-.93-.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M178.17,260.07c-.22-.51,.02-1.1,.53-1.31h0c.51-.22,1.09,.02,1.31,.53h0c.22,.5-.02,1.09-.53,1.31h0c-.13,.05-.26,.08-.39,.08h0c-.39,0-.76-.23-.92-.61Zm-2.5-6.63c-.17-.52,.11-1.09,.64-1.26h0c.52-.17,1.09,.11,1.26,.64h0c.17,.52-.11,1.09-.64,1.26h0c-.1,.03-.21,.05-.31,.05h0c-.42,0-.81-.27-.95-.69Zm-1.94-6.8h0c-.13-.54,.2-1.08,.73-1.21h0c.54-.13,1.08,.2,1.21,.74h0c.13,.53-.2,1.07-.74,1.2h0c-.07,.02-.15,.03-.23,.03h0c-.45,0-.86-.3-.97-.76Zm-1.38-6.94c-.09-.55,.28-1.06,.83-1.15h0c.54-.08,1.06,.29,1.14,.84h0c.09,.54-.29,1.05-.83,1.14h0c-.05,.01-.11,.01-.16,.01h0c-.48,0-.91-.35-.98-.84Zm-.81-7.04c-.04-.55,.37-1.03,.92-1.07h0c.55-.04,1.03,.38,1.07,.93h0c.04,.55-.37,1.03-.92,1.07h-.08c-.52,0-.96-.4-.99-.93Zm.75-6.06c-.55-.01-1-.46-.99-1.01h0c0-.55,.45-1,1-.99h0c.56,0,1,.45,1,1h0c-.01,.55-.45,1-1,1h-.01Zm.24-7c-.54-.05-.95-.53-.9-1.08h0c.04-.55,.53-.96,1.08-.91h0c.55,.05,.96,.53,.91,1.08h0c-.05,.52-.48,.91-1,.91h-.09Zm.82-6.95c-.55-.09-.92-.61-.82-1.15h0c.09-.55,.6-.91,1.15-.82h0c.54,.09,.91,.61,.82,1.15h0c-.09,.49-.51,.83-.99,.83h0c-.05,0-.11,0-.16,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M470.98,82.23c-.31-.46-.18-1.08,.28-1.38h0c.46-.31,1.08-.18,1.38,.28h0c.31,.46,.18,1.08-.28,1.38h0c-.17,.11-.36,.17-.55,.17h0c-.32,0-.64-.16-.83-.45Zm-3.97-5.71h0c-.32-.45-.22-1.08,.22-1.4h0c.45-.33,1.07-.23,1.4,.22h0c.32,.45,.22,1.07-.22,1.4h0c-.18,.13-.39,.19-.59,.19h0c-.31,0-.62-.14-.81-.41Zm-4.2-5.55c-.34-.44-.27-1.06,.17-1.41h0c.43-.34,1.06-.27,1.4,.17h0c.34,.43,.27,1.06-.16,1.4h0c-.19,.15-.41,.22-.62,.22h0c-.3,0-.59-.13-.79-.38Zm-4.42-5.37c-.36-.42-.31-1.06,.1-1.42h0c.43-.35,1.06-.31,1.42,.11h0c.36,.42,.31,1.05-.11,1.41h0c-.19,.16-.42,.24-.65,.24h0c-.28,0-.56-.11-.76-.34Zm-4.64-5.19c-.38-.4-.36-1.04,.05-1.41h0c.4-.38,1.04-.36,1.41,.05h0c.38,.4,.36,1.03-.05,1.41h0c-.19,.18-.43,.27-.68,.27h0c-.27,0-.53-.11-.73-.32Zm-4.85-4.99h0c-.39-.39-.39-1.02-.01-1.42h0c.39-.39,1.03-.39,1.42,0h0c.39,.38,.39,1.02,.01,1.41h0c-.2,.2-.46,.3-.71,.3h0c-.26,0-.51-.1-.71-.29Zm-5.05-4.79c-.4-.38-.43-1.01-.06-1.42h0c.37-.4,1-.43,1.41-.06h0c.41,.37,.44,1,.07,1.41h0c-.2,.22-.47,.33-.74,.33h0c-.24,0-.48-.09-.68-.26Zm-5.24-4.58c-.42-.36-.47-.99-.12-1.41h0c.36-.42,.99-.48,1.41-.12h0c.42,.35,.48,.98,.12,1.4h0c-.19,.24-.48,.36-.76,.36h0c-.23,0-.46-.07-.65-.23Zm-5.42-4.36c-.43-.34-.52-.97-.18-1.41h0c.34-.43,.97-.51,1.4-.18h0c.44,.34,.52,.97,.19,1.41h0c-.2,.25-.5,.38-.8,.38h0c-.21,0-.43-.06-.61-.2Zm-5.59-4.14c-.45-.32-.56-.94-.24-1.39h0c.32-.45,.94-.56,1.39-.24h0c.45,.32,.56,.94,.24,1.39h0c-.19,.28-.5,.43-.82,.43h0c-.2,0-.4-.06-.57-.19Zm-5.77-3.9c-.46-.3-.59-.92-.29-1.38h0c.3-.47,.92-.6,1.38-.3h0c.47,.3,.6,.92,.3,1.38h0c-.19,.3-.51,.46-.84,.46h0c-.19,0-.38-.05-.55-.16Zm-5.91-3.66c-.48-.28-.63-.9-.35-1.37h0c.28-.48,.89-.64,1.37-.35h0c.47,.28,.63,.89,.35,1.36h0c-.19,.32-.52,.5-.86,.5h0c-.18,0-.35-.05-.51-.14Zm-6.06-3.42c-.49-.26-.67-.87-.41-1.35h0c.26-.49,.86-.67,1.35-.41h0c.49,.26,.67,.87,.41,1.35h0c-.18,.34-.53,.53-.88,.53h0c-.16,0-.32-.04-.47-.12Zm-6.2-3.16c-.5-.24-.71-.84-.47-1.34h0c.24-.5,.84-.7,1.34-.46h0c.5,.24,.7,.84,.46,1.33h0c-.17,.36-.53,.57-.9,.57h0c-.14,0-.29-.03-.43-.1Zm-6.33-2.91c-.5-.22-.73-.8-.52-1.31h0c.22-.51,.81-.74,1.32-.52h0c.51,.22,.74,.81,.52,1.32h0c-.16,.37-.53,.6-.92,.6h0c-.13,0-.27-.03-.4-.09Zm-6.43-2.64c-.52-.2-.77-.77-.58-1.29h0c.2-.51,.78-.77,1.3-.57h0c.51,.2,.77,.77,.57,1.29h0c-.15,.4-.53,.64-.93,.64h0c-.12,0-.25-.02-.36-.07Zm-6.55-2.37c-.52-.18-.8-.74-.62-1.27h0c.18-.52,.74-.8,1.27-.62h0c.52,.17,.8,.74,.62,1.27h0c-.14,.41-.53,.68-.94,.68h0c-.11,0-.22-.02-.33-.06Zm-6.63-2.1c-.53-.15-.83-.71-.68-1.24h0c.16-.53,.71-.83,1.24-.67h0c.53,.15,.83,.71,.68,1.24h0c-.13,.43-.53,.72-.96,.72h0c-.09,0-.19-.02-.28-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M134.35,284.99h0c-.55,0-.99-.46-.99-1.01h0c.01-.55,.47-1,1.02-.99h0c.55,.01,.99,.46,.98,1.02h0c0,.54-.45,.98-1,.98h-.01Zm6.01-1.13c-.04-.55,.37-1.03,.93-1.07h0c.55-.04,1.02,.37,1.07,.93h0c.04,.55-.38,1.02-.93,1.07h-.07c-.52,0-.96-.4-1-.93Zm-13.08,.72c-.55-.06-.95-.55-.9-1.1h0c.06-.55,.55-.95,1.1-.89h0c.55,.05,.95,.54,.89,1.1h0c-.05,.51-.48,.89-.99,.89h-.1Zm20.04-1.45c-.09-.55,.28-1.06,.83-1.15h-.01c.55-.09,1.06,.28,1.15,.83h0c.09,.54-.28,1.05-.82,1.14h0c-.06,.01-.11,.02-.16,.02h0c-.48,0-.91-.35-.99-.84Zm-27.05,.41c-.54-.11-.9-.63-.79-1.18h0c.1-.54,.63-.89,1.17-.79h0c.54,.11,.9,.63,.79,1.17h0c-.09,.48-.51,.81-.98,.81h0c-.06,0-.13,0-.19,0Zm33.92-1.76c-.14-.54,.18-1.08,.71-1.22h0c.54-.14,1.08,.18,1.22,.72h0c.14,.53-.18,1.08-.72,1.22h0c-.08,.02-.16,.03-.24,.03h0c-.45,0-.86-.3-.97-.75Zm-40.81,.09c-.53-.15-.84-.71-.68-1.24h0c.15-.53,.71-.83,1.23-.68h0c.54,.15,.84,.71,.69,1.24h0c-.13,.44-.53,.72-.96,.72h0c-.09,0-.19,0-.28-.04Zm47.52-2.05c-.18-.52,.09-1.1,.61-1.28h0c.52-.19,1.09,.08,1.28,.6h0c.18,.53-.09,1.1-.61,1.28h0c-.11,.04-.22,.06-.33,.06h0c-.42,0-.8-.25-.95-.66Zm-54.23-.23c-.52-.2-.77-.78-.57-1.29h0c.2-.52,.78-.77,1.29-.57h0c.52,.2,.77,.78,.57,1.3h0c-.15,.39-.53,.63-.93,.63h0c-.12,0-.24-.02-.36-.07Zm60.75-2.33c-.23-.5-.01-1.1,.49-1.33h0c.5-.23,1.09,0,1.32,.49h0c.23,.5,.01,1.1-.49,1.33h0c-.13,.06-.27,.09-.41,.09h0c-.38,0-.74-.21-.91-.58Zm-67.23-.54c-.5-.24-.7-.84-.45-1.34h0c.24-.49,.84-.69,1.34-.45h0c.49,.25,.69,.85,.45,1.34h0c-.18,.36-.53,.56-.9,.56h0c-.15,0-.3-.03-.44-.11Zm73.49-2.59c-.28-.48-.11-1.09,.36-1.36h0c.48-.28,1.09-.11,1.37,.37h0c.27,.47,.11,1.09-.37,1.36h0c-.16,.09-.33,.13-.49,.13h0c-.35,0-.69-.18-.87-.5Zm-79.69-.84c-.47-.29-.62-.91-.33-1.38h0c.29-.47,.9-.62,1.38-.33h0c.46,.29,.61,.91,.32,1.38h0c-.19,.31-.51,.48-.85,.48h0c-.18,0-.36-.05-.52-.15Zm-5.87-3.98c-.44-.33-.53-.96-.2-1.4h0c.33-.44,.95-.53,1.4-.2h0c.44,.33,.53,.95,.2,1.39h0c-.2,.27-.5,.41-.8,.41h0c-.21,0-.42-.07-.6-.2Zm-5.49-4.48c-.41-.37-.45-1-.08-1.41h0c.37-.41,1-.45,1.41-.08h0c.41,.37,.45,1,.08,1.41h0c-.19,.22-.47,.34-.74,.34h0c-.24,0-.48-.09-.67-.26Zm-5.07-4.95c-.38-.4-.36-1.03,.04-1.41h0c.41-.38,1.04-.36,1.42,.04h0c.38,.41,.36,1.04-.05,1.42h0c-.19,.18-.44,.27-.68,.27h0c-.27,0-.53-.11-.73-.32Zm-4.61-5.38c-.34-.43-.27-1.06,.17-1.4h0c.43-.34,1.06-.26,1.4,.17h0c.34,.44,.27,1.06-.17,1.4h0c-.18,.15-.4,.22-.62,.22h0c-.29,0-.59-.13-.78-.39Zm-4.12-5.76c-.3-.46-.17-1.08,.29-1.38h0c.47-.3,1.09-.17,1.39,.29h0c.3,.46,.17,1.08-.3,1.38h0c-.16,.11-.35,.16-.54,.16h0c-.33,0-.65-.16-.84-.45Zm-3.59-6.11c-.26-.49-.07-1.09,.42-1.35h0c.49-.26,1.09-.07,1.35,.42h0c.26,.48,.07,1.09-.42,1.35h0c-.15,.08-.31,.11-.46,.11h0c-.36,0-.71-.19-.89-.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M326.17,175.42c-.33-.44-.24-1.07,.2-1.4h0c.44-.33,1.07-.24,1.4,.2h0c.33,.45,.24,1.07-.2,1.4h0c-.18,.14-.39,.2-.6,.2h0c-.3,0-.6-.13-.8-.4Zm-4.37-5.36c-.36-.42-.32-1.05,.09-1.41h0c.42-.37,1.05-.33,1.41,.08h0c.37,.42,.33,1.05-.08,1.42h0c-.19,.16-.43,.25-.67,.25h0c-.27,0-.55-.12-.75-.34Zm-4.78-5h0c-.39-.39-.41-1.02-.02-1.42h0c.38-.39,1.02-.4,1.41-.02h0c.4,.38,.41,1.01,.03,1.41h0c-.2,.21-.46,.31-.72,.31h0c-.25,0-.5-.09-.7-.28Zm-5.16-4.6c-.43-.35-.49-.98-.14-1.41h0c.35-.43,.98-.49,1.41-.14h0c.42,.35,.49,.98,.13,1.41h0c-.19,.24-.48,.36-.77,.36h0c-.22,0-.45-.07-.63-.22Zm-5.52-4.17c-.46-.32-.57-.94-.25-1.4h0c.31-.45,.94-.56,1.39-.25h0c.45,.32,.57,.94,.25,1.39h0c-.19,.28-.51,.43-.82,.43h0c-.2,0-.4-.05-.57-.17Zm-5.84-3.72c-.47-.28-.64-.89-.36-1.37h0c.28-.47,.89-.64,1.37-.36h0c.47,.28,.64,.89,.36,1.37h0c-.19,.32-.52,.5-.87,.5h0c-.17,0-.34-.05-.5-.14Zm-6.12-3.23c-.49-.24-.71-.84-.47-1.33h0c.24-.5,.84-.71,1.34-.47h0c.49,.23,.7,.83,.47,1.33h0c-.17,.36-.53,.57-.91,.57h0c-.14,0-.29-.03-.43-.1Zm-61.96-5.69c-.16-.53,.15-1.09,.68-1.24h0c.53-.15,1.09,.15,1.24,.69h0c.15,.53-.15,1.08-.69,1.23h0c-.09,.03-.18,.04-.27,.04h0c-.44,0-.84-.28-.96-.72Zm42.32-.89h0c-.54-.12-.89-.65-.77-1.18h0c.11-.55,.63-.9,1.17-.79h0c.55,.12,.9,.64,.78,1.19h0c-.09,.47-.51,.8-.97,.8h0c-.07,0-.14,0-.21-.02Zm-35.55-.85c-.1-.54,.25-1.07,.79-1.18h0c.54-.11,1.07,.24,1.18,.78h0c.1,.55-.25,1.07-.79,1.18h0c-.06,0-.13,.02-.2,.02h0c-.46,0-.88-.33-.98-.8Zm28.72-.27c-.55-.06-.94-.56-.87-1.11h0c.07-.55,.57-.94,1.11-.87h0c.55,.06,.94,.56,.88,1.11h0c-.07,.51-.5,.88-1,.88h0s-.08,0-.12-.01Zm-21.82-.92c-.06-.54,.33-1.04,.88-1.11h0c.55-.06,1.04,.33,1.11,.88h0c.06,.55-.33,1.04-.88,1.11h0s-.08,0-.12,0h0c-.5,0-.93-.38-.99-.89Zm14.93,.36c-.55-.03-.98-.49-.96-1.04h0c.02-.56,.49-.98,1.04-.96h0c.55,.02,.98,.49,.96,1.04h0c-.02,.54-.47,.96-1,.96h-.04Zm-7.96-.98c-.02-.55,.41-1.02,.96-1.04h0c.56-.02,1.02,.41,1.04,.96h0c.02,.56-.41,1.02-.96,1.04h-.04c-.53,0-.98-.42-1-.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M220.34,303.75c-.5-.25-.69-.85-.44-1.35h0c.25-.49,.85-.69,1.34-.44h0c.49,.25,.69,.86,.44,1.35h0c-.18,.35-.53,.55-.89,.55h0c-.16,0-.31-.04-.45-.11Zm-6.18-3.46c-.47-.29-.62-.9-.33-1.37h0c.28-.47,.9-.62,1.37-.33h0c.47,.29,.62,.9,.33,1.37h0c-.19,.31-.52,.48-.85,.48h0c-.18,0-.36-.05-.52-.15Zm-5.89-3.93c-.44-.33-.54-.95-.21-1.4h0c.32-.45,.95-.54,1.39-.22h0c.45,.33,.55,.95,.22,1.4h0c-.19,.27-.5,.41-.81,.41h0c-.2,0-.41-.06-.59-.19Zm-5.54-4.4c-.42-.36-.47-.99-.11-1.41h0c.36-.42,.99-.47,1.41-.11h0c.42,.36,.47,1,.11,1.41h0c-.2,.23-.48,.35-.76,.35h0c-.23,0-.47-.08-.65-.24Zm-5.18-4.82c-.39-.4-.39-1.03,0-1.42h0c.4-.39,1.03-.38,1.42,.01h0c.39,.39,.38,1.02-.01,1.41h0c-.19,.2-.45,.29-.7,.29h0c-.26,0-.52-.1-.71-.29Zm-4.78-5.23c-.35-.42-.3-1.05,.12-1.41h0c.43-.35,1.06-.3,1.41,.12h0c.36,.42,.3,1.06-.12,1.41h0c-.18,.16-.41,.24-.64,.24h0c-.29,0-.57-.12-.77-.36Zm-4.34-5.59c-.32-.45-.21-1.07,.24-1.4h0c.45-.32,1.07-.21,1.39,.24h0c.32,.45,.22,1.07-.23,1.39h0c-.18,.13-.38,.19-.58,.19h0c-.31,0-.62-.15-.82-.42Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Art"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M574,305.89V116.42c-21.59-18.25-49.51-29.27-80-29.27-43.73,0-82.17,22.65-104.25,56.85,0,0,0,0,0,0h-38.63v32.11c-44.19,.37-79.9,36.29-79.9,80.57,0,18.59,6.31,35.69,16.89,49.33h285.76s.09-.08,.14-.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M360.41,176.55c1.88,.2,3.75,.47,5.59,.8-1.84-.33-3.71-.6-5.59-.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M375.46,174.71c.02-.08,.04-.15,.07-.23-.02,.08-.04,.15-.07,.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M376.96,170.14c.04-.11,.08-.22,.12-.33-.04,.11-.08,.22-.12,.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M378.65,165.59c.05-.12,.09-.24,.14-.36-.05,.12-.09,.24-.14,.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M380.54,161.09c.05-.11,.1-.22,.14-.33-.05,.11-.1,.22-.14,.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M382.59,156.67c.04-.09,.09-.18,.13-.26-.04,.09-.09,.18-.13,.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M384.82,152.35c.03-.06,.07-.13,.1-.19-.03,.06-.07,.13-.1,.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M387.21,148.12s.04-.06,.05-.09c-.02,.03-.04,.06-.05,.09Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-22",
    cx: 55.46,
    cy: 179.46,
    r: 53.46
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 154.3,
    cy: 131.34,
    r: 75.34
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M150.14,92.49h79.95v40.38c0,2.5-2.03,4.52-4.52,4.52h-75.43v-44.9h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 102.02,
    y: 135.62,
    width: 61.78,
    height: 104.85
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 107.8,
    cy: 144.43,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 112,
    cy: 144.43,
    r: 1.26
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 118.29,
    y: 143.4,
    width: 45.8,
    height: 1.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 107.8,
    cy: 157.85,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 112,
    cy: 157.85,
    r: 1.26
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 118.29,
    y: 156.82,
    width: 45.8,
    height: 1.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 107.8,
    cy: 171.27,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 112,
    cy: 171.27,
    r: 1.26
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 118.29,
    y: 170.24,
    width: 45.8,
    height: 1.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 107.8,
    cy: 184.69,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 112,
    cy: 184.69,
    r: 1.26
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 118.29,
    y: 183.66,
    width: 45.8,
    height: 1.82
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 107.8,
    cy: 198.95,
    r: 1.26
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-21",
    cx: 112,
    cy: 198.95,
    r: 1.26
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 118.29,
    y: 197.92,
    width: 45.8,
    height: 1.82
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 150.14,
    y: 92.49,
    width: 79.95,
    height: 132.52
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 151.95,
    y: 97.94,
    width: 76.32,
    height: 23.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 162.86,
    y: 108.84,
    width: 36.34,
    height: 1.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 209.19,
    cy: 109.75,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 216,
    cy: 109.75,
    r: 1.36
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 151.95,
    y: 156.09,
    width: 76.32,
    height: 37.05
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 157.4,
    y: 172.03,
    width: 65.41,
    height: 16.35
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 162.86,
    y: 179.3,
    width: 51.14,
    height: 1.82
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 216,
    cy: 180.21,
    r: 1.36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 151.95,
    y: 123.38,
    width: 76.32,
    height: 30.89
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 157.4,
    y: 127.92,
    width: 65.41,
    height: 6.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 162.4,
    cy: 131.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 161.95,
    cy: 141.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 168.31,
    cy: 141.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 174.67,
    cy: 141.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 181.03,
    cy: 141.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 187.39,
    cy: 141.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 193.75,
    cy: 141.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 200.1,
    cy: 141.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 206.46,
    cy: 141.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 212.82,
    cy: 141.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 219.18,
    cy: 141.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 161.95,
    cy: 148.36,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 168.31,
    cy: 148.36,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 174.67,
    cy: 148.36,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 181.03,
    cy: 148.36,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 187.39,
    cy: 148.36,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 193.75,
    cy: 148.36,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 200.1,
    cy: 148.36,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 206.46,
    cy: 148.36,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 212.82,
    cy: 148.36,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 219.18,
    cy: 148.36,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 165.58,
    cy: 144.73,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 171.94,
    cy: 144.73,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 178.3,
    cy: 144.73,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 184.66,
    cy: 144.73,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 191.02,
    cy: 144.73,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 197.38,
    cy: 144.73,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 203.74,
    cy: 144.73,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 210.1,
    cy: 144.73,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-23",
    cx: 216.46,
    cy: 144.73,
    r: 1.36
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 166.94,
    cy: 131.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 171.49,
    cy: 131.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 213.28,
    cy: 131.1,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 217.82,
    cy: 131.1,
    r: 1.36
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 151.95,
    y: 195.51,
    width: 76.32,
    height: 30.89
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 161.95,
    cy: 213.23,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 168.31,
    cy: 213.23,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 174.67,
    cy: 213.23,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 181.03,
    cy: 213.23,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 187.39,
    cy: 213.23,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 193.75,
    cy: 213.23,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 200.1,
    cy: 213.23,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 206.46,
    cy: 213.23,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 212.82,
    cy: 213.23,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 219.18,
    cy: 213.23,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 161.95,
    cy: 220.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 168.31,
    cy: 220.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 174.67,
    cy: 220.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 181.03,
    cy: 220.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 187.39,
    cy: 220.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 193.75,
    cy: 220.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 200.1,
    cy: 220.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 206.46,
    cy: 220.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 212.82,
    cy: 220.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 219.18,
    cy: 220.5,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 165.58,
    cy: 216.86,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 171.94,
    cy: 216.86,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 178.3,
    cy: 216.86,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 184.66,
    cy: 216.86,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 191.02,
    cy: 216.86,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 197.38,
    cy: 216.86,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 203.74,
    cy: 216.86,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 210.1,
    cy: 216.86,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 216.46,
    cy: 216.86,
    r: 1.36
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 213.28,
    cy: 203.24,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-36",
    cx: 217.82,
    cy: 203.24,
    r: 1.36
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-31",
    points: "157.4 160.63 157.4 162.2 157.4 167.14 224 167.14 224 162.2 224 160.63 157.4 160.63"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 162.4,
    cy: 163.81,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 166.94,
    cy: 163.81,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 171.49,
    cy: 163.81,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 213.28,
    cy: 163.81,
    r: 1.36
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 217.82,
    cy: 163.81,
    r: 1.36
  })))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M228.92,120.75c.26,1.87,.46,3.74,.58,5.62,.73,11.18-1.05,22.36-5.14,32.71"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 223.95,
    y: 97.94,
    width: 4.32,
    height: 23.62
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 214.08,
    y: 97.94,
    width: 14.19,
    height: 4.41
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 157.4,
    y: 101.57,
    width: 65.41,
    height: 16.35
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M279.33,0c-9.53,10.76-15.33,24.91-15.33,40.42,0,33.69,27.31,61,61,61s61-27.31,61-61c0-15.51-5.8-29.65-15.33-40.42h-91.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 291.47,
    y: 25.99,
    width: 68.03,
    height: 14.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 291.47,
    y: 25.99,
    width: 68.03,
    height: 13.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 299.47,
    y: 40,
    width: 52.02,
    height: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 293.47,
    y: 27.99,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 298.97,
    y: 27.99,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 352.5,
    y: 27.99,
    width: 1,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 355.5,
    y: 27.99,
    width: 1,
    height: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 291.47,
    y: 43.99,
    width: 68.03,
    height: 14.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 291.47,
    y: 43.99,
    width: 68.03,
    height: 13.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 299.47,
    y: 58,
    width: 52.02,
    height: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 293.47,
    y: 45.99,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 298.97,
    y: 45.99,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 352.5,
    y: 45.99,
    width: 1,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 355.5,
    y: 45.99,
    width: 1,
    height: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 291.47,
    y: 61.99,
    width: 68.03,
    height: 14.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 291.47,
    y: 61.99,
    width: 68.03,
    height: 13.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 299.47,
    y: 76,
    width: 52.02,
    height: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 293.47,
    y: 63.99,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 298.97,
    y: 63.99,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 352.5,
    y: 63.99,
    width: 1,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 355.5,
    y: 63.99,
    width: 1,
    height: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 291.47,
    y: 79.99,
    width: 68.03,
    height: 14.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 291.47,
    y: 79.99,
    width: 68.03,
    height: 13.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 299.47,
    y: 94,
    width: 52.02,
    height: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 293.47,
    y: 81.99,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 298.97,
    y: 81.99,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 352.5,
    y: 81.99,
    width: 1,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 355.5,
    y: 81.99,
    width: 1,
    height: 10
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 291.47,
    y: 97.99,
    width: 68.03,
    height: 14.01
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 291.47,
    y: 97.99,
    width: 68.03,
    height: 13.93
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 299.47,
    y: 112,
    width: 52.02,
    height: 4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 293.47,
    y: 99.99,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 298.97,
    y: 99.99,
    width: 3,
    height: 3,
    rx: 1.5,
    ry: 1.5
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 352.5,
    y: 99.99,
    width: 1,
    height: 10
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 355.5,
    y: 99.99,
    width: 1,
    height: 10
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M154.3,206.69c-41.61,0-75.34-33.73-75.34-75.34,0-18.87,6.94-36.13,18.41-49.34"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M227.8,148c-7.58,33.6-37.61,58.69-73.5,58.69"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M108.93,179.46c0,25.92-18.45,47.53-42.93,52.43"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M562,107.44c-19.53-12.83-42.89-20.29-68-20.29-45.42,0-85.13,24.42-106.73,60.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M351,176.09c-44.5,0-79.78,36.08-79.78,80.58"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 234,
    y: 212,
    width: 84.07,
    height: 57.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 234,
    y: 212,
    width: 84.07,
    height: 57.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 234,
    y: 212,
    width: 84.07,
    height: 7.88
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 234,
    y1: 219.88,
    x2: 318.07,
    y2: 219.88
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 287.42,
    y: 238.71,
    width: 22.77,
    height: 2.85,
    transform: "translate(597.6 480.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 287.42,
    y: 244.4,
    width: 19.92,
    height: 2.85,
    transform: "translate(594.76 491.65) rotate(180)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M260.91,244.4h3.74c0-6.28-5.11-11.38-11.38-11.38v3.74c4.22,0,7.64,3.43,7.64,7.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M253.27,255.79c-6.28,0-11.38-5.11-11.38-11.38,0-6.28,5.11-11.38,11.38-11.38v3.74c-4.21,0-7.64,3.43-7.64,7.64,0,4.22,3.43,7.64,7.64,7.64,4.21,0,7.64-3.43,7.64-7.64h3.74c0,6.28-5.11,11.38-11.38,11.38Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 278.88,
    y: 238.71,
    width: 2.85,
    height: 2.85,
    transform: "translate(560.61 480.26) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 278.88,
    y: 244.4,
    width: 2.85,
    height: 2.85,
    transform: "translate(560.61 491.65) rotate(180)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M328.9,278c-.16-.76-.38-1.49-.68-2.19-.88-2.09-2.36-3.87-4.22-5.13-.31-.21-.63-.4-.96-.58-1.65-.9-3.54-1.41-5.55-1.41-.36,0-.72,.02-1.07,.05-.11,0-.21,.02-.31,.04-.26,.03-.52,.07-.77,.12-.1,.02-.2,.04-.3,.06-.22,.05-.43,.11-.65,.17-1.47-5.37-5.33-9.75-10.39-11.89-.54-.23-1.1-.43-1.66-.61-1.13-.35-2.31-.6-3.53-.72-.61-.06-1.22-.09-1.85-.09s-1.18,.03-1.76,.09c-.2,.02-.39,.06-.59,.08-.38,.05-.75,.1-1.12,.17-.23,.05-.46,.11-.69,.16-.32,.08-.64,.15-.96,.25-.24,.07-.48,.15-.71,.23-.18,.06-.36,.11-.54,.18-.13,.05-.26,.11-.39,.16-.18,.07-.36,.15-.54,.23-.34,.15-.68,.31-1.01,.48-.14,.07-.29,.14-.43,.22-.45,.25-.89,.52-1.32,.8-.11,.07-.21,.15-.32,.23-.33,.23-.64,.46-.95,.71-.14,.12-.28,.24-.43,.36-.27,.23-.54,.47-.79,.72-.13,.12-.26,.24-.38,.37-.32,.33-.64,.67-.94,1.03-.04,.05-.08,.09-.12,.13-.33,.4-.64,.82-.93,1.25-.09,.14-.18,.28-.27,.41-.2,.31-.4,.63-.58,.95-.09,.16-.18,.31-.26,.47-.14,.27-.27,.54-.4,.81-.18,0-.37,.02-.55,.03-.12,.01-.24,.03-.35,.04-.26,.03-.52,.07-.78,.12-.13,.02-.25,.05-.38,.08-.27,.06-.53,.13-.79,.2-.09,.03-.19,.05-.28,.08-.02,0-.04,0-.06,.02-.33,.11-.65,.23-.96,.36-.1,.04-.19,.09-.29,.13-.24,.11-.47,.22-.7,.34-.12,.06-.24,.13-.36,.2-.2,.12-.4,.24-.6,.36-.12,.08-.23,.15-.35,.23-.21,.14-.4,.29-.6,.45-.09,.07-.18,.14-.27,.21-.27,.23-.54,.47-.79,.72-.06,.06-.11,.12-.17,.18-.19,.2-.38,.41-.57,.62-.08,.1-.16,.2-.24,.3-.15,.19-.29,.38-.43,.58-.08,.11-.15,.22-.22,.33-.14,.21-.27,.43-.4,.65-.06,.1-.12,.19-.17,.29-.17,.32-.33,.65-.47,.99-.02,.04-.03,.09-.05,.13-.12,.3-.23,.6-.33,.91-.04,.12-.07,.23-.1,.35-.07,.25-.14,.49-.19,.74-.03,.13-.06,.26-.08,.39-.05,.26-.09,.52-.12,.78-.01,.12-.03,.24-.04,.36-.02,.23-.03,.47-.04,.71-.19,0-.39,.01-.58,.03-.12,.01-.24,.03-.36,.05-.09,.01-.18,.02-.27,.04,0,0-.01,0-.02,0-.36,.07-.72,.17-1.06,.3-.04,.02-.09,.03-.13,.05-.33,.13-.65,.28-.95,.46-.04,.03-.09,.05-.13,.08-.3,.18-.59,.39-.86,.62-.02,.02-.05,.04-.07,.06-.27,.24-.53,.49-.76,.76,0,0-.02,.02-.02,.03-.23,.27-.43,.57-.61,.87-.03,.04-.05,.09-.08,.13-.17,.3-.32,.61-.44,.93-.02,.06-.04,.12-.06,.17-.12,.33-.21,.67-.28,1.02,0,.05-.01,.1-.02,.15-.06,.37-.1,.75-.1,1.13,0,3.77,3.03,6.83,6.78,6.89h0s.11,0,.11,0h48.6s.73-.03,.73-.03c5.12,.03,8.28-4.25,8.33-4.31,.2-.25,.4-.51,.58-.78,.02-.03,.04-.06,.06-.09,.17-.25,.33-.52,.48-.79,.03-.05,.06-.11,.09-.16,.15-.29,.29-.58,.42-.88,.03-.06,.05-.13,.08-.19,.13-.31,.25-.62,.35-.95,0-.02,0-.04,.02-.05,.1-.31,.18-.63,.25-.96,.01-.06,.03-.13,.04-.19,.07-.33,.12-.66,.15-1,0-.07,.01-.14,.02-.2,.03-.35,.05-.71,.05-1.07,0-.8-.08-1.59-.24-2.35Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    className: "cls-24",
    d: "M297.84,268.85c1.97,0,3.57,1.59,3.57,3.55,0,1.34-.75,2.51-1.85,3.11l.51,4.59c.02,.18-.11,.34-.29,.36h-.02s-3.84,0-3.84,0c-.18,0-.32-.14-.32-.32,0-.01,0-.02,0-.04l.51-4.59c-1.1-.6-1.85-1.77-1.85-3.11,0-1.96,1.6-3.55,3.57-3.55Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M325,100.92c-33.36,0-60.5-27.14-60.5-60.5,0-15.52,5.88-29.7,15.53-40.42h-1.32c-9.46,10.82-15.21,24.95-15.21,40.42,0,33.91,27.59,61.5,61.5,61.5,21.69,0,41.37-11.09,52.63-29.66l-.85-.52c-11.08,18.27-30.43,29.18-51.77,29.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154.3,206.69c-41.61,0-75.34-33.73-75.34-75.34S112.69,56,154.3,56c15.42,0,29.76,4.63,41.7,12.58"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M558.26,104.5l-.52,.86c5.71,3.45,11.16,7.39,16.26,11.72v-1.31c-4.95-4.16-10.22-7.93-15.74-11.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Person"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 351.12,
    y: 144,
    width: 222.88,
    height: 139
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 400.97,
    cy: 235.22,
    r: 6.2
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M410.27,210.43l-.39-10.85-.39-10.85c0-.86-.69-1.55-1.55-1.55s-1.55,.69-1.55,1.55l-.39,10.85-.39,10.85h-13.95s0,12.4,0,15.5,3.1,9.3,3.1,9.3h12.4l3.1-15.5v-9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M394.77,213.53s0,12.4,6.2,12.4c3.1-3.1,9.3-6.2,9.3-6.2,0,0,0-2.99,0-6.16,0-.93-2.32-3.61-4.54-6.24,0,0,.3,6.2-1.66,6.2h-9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M405.6,210.15l-.95-4.57h0c-.12-1.01-1-1.76-2.03-1.7-1.07,.06-1.88,.98-1.82,2.05v.12s.01,0,.01,0l.04,.92-.18-1.49h0c-.14-.91-.92-1.62-1.87-1.64-1.07-.02-1.95,.83-1.97,1.89h0l-.2,1.94-.23-.76h0c-.27-.77-1-1.32-1.87-1.3-.93,.02-1.69,.69-1.86,1.57h0s-.76,2.27-.76,2.27c-.08,.17-.14,.34-.18,.53-.24,1.26,.58,2.48,1.84,2.72,.33,.06,.66,.05,.97-.02l1.31,3.26c.28,.81,1.17,1.23,1.97,.95,.46-.16,.79-.52,.94-.94l.15,.77c.13,.85,.93,1.42,1.77,1.29,.54-.08,.97-.44,1.17-.9l.04,.39c.05,.85,.79,1.5,1.64,1.45,.85-.05,1.5-.79,1.45-1.64l-.14-5.16c.55-.49,.86-1.23,.76-2.02Zm-7.48,2.55l.03,.17-.05-.18s.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M404.94,217v-1s-4.97-2.44-3.25-6.59l7.51,3.97,2.61,9.45-4.65,12.4h-6.2c-3.1-12.4,3.97-18.23,3.97-18.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M405.33,215.77c-2.33-1.11-4.86-3.58-3.64-6.36-.67,1.23-.61,2.76,.11,3.98,.67,1.16,1.64,2.06,2.75,2.81v.66c-4.59,4.89-5.21,12.08-3.58,18.37-1.37-6.32-.49-13.47,4.36-18.07,0-.27,0-1.12,0-1.39Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M564,267.38c-2.56-8.23-8.94-28.78-10.01-32.21-1.19-4.59-4.88-7.81-8.81-8.83-8.86-2.3-25.59-6.61-31.08-6.61v1.27h-24.8v-1.27c-5.5,0-22.23,4.31-31.08,6.61-3.02,.78-5.9,2.87-7.61,5.87-2.22,3.44-13.6,21.05-18.21,28.17-2.36,3.66-6.36,9.84-10.56,16.34-5.11-21.35-11.85-42.83-11.85-42.83l-11.25,2.33-3.93,.81-3.03,.63s5.77,43.12,8.29,55.26c.73,3.5,1.87,9.02,2.71,13.07h30.94c6.83-8.79,16.66-21.62,21.4-28.66,1.96,13.67,1.14,26.06,.93,28.66h89.13c.22-1.31,.84-5.1,1.67-10.28,1.09,3.5,2.18,7.02,3.19,10.28h23.96v-6.42c-3.45-11.11-7.91-25.45-10-32.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M525.85,225.2h-47.69c0-11.29-3.44-21.2,7.85-21.2l24-2c11.29,0,22,10.71,22,22l-6.15,1.2Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M492,234s-6,7.63-6-6c0-10.9-9.25-.64-4-2,7.95-2.06-2.65-4.59,3.5-5.82,1.27-.25,2.19-1.37,2.19-2.67v-15.48h28.62v15.48c0,1.3,.92,2.42,2.19,2.67,6.15,1.22,3.55-.25,11.5,1.82,5.25,1.36-10-6.9-10,4,0,13.63-18,12-18,12l-10-4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M502.68,215.66h-14.99v-13.63h28.62c0,7.53-6.1,13.63-13.63,13.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M529.91,167.97c0-1.36-1.36-2.73-2.73-2.73h-1.59c.16-1.11,.25-2.25,.25-3.41,0-13.17-10.68-23.85-23.85-23.85s-23.85,10.68-23.85,23.85c0,1.16,.09,2.29,.25,3.41h-1.61c-1.36,0-2.73,1.36-2.73,2.72,0,0,.41,17.71,6.11,17.71l-1.75-20.29h0l2.46,28.47c0,4.09,9.54,10.9,9.54,10.9,0,0,4.8,5.45,11.58,5.45s11.58-5.45,11.58-5.45c0,0,9.54-6.81,9.54-10.9l.7-8.18c5.68-.03,6.09-17.71,6.09-17.71Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M529.93,214.3c0-10.78-13.63-10.9-13.63-10.9v1.36s8.18,1.34,8.18,5.45c0,8.54-22.48,25.89-22.48,25.89,0,0-22.48-17.35-22.48-25.89,0-4.11,8.18-5.45,8.18-5.45v-1.36s-13.63,.12-13.63,10.9c0,0-4.09-.68-4.09,9.54,0,0,14.1,14.99,32.02,14.99s32.02-14.99,32.02-14.99c0-10.22-4.09-9.54-4.09-9.54Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 514.95,
    y: 229.29,
    width: 1.36,
    height: 32.7,
    rx: 0.68,
    ry: 0.68,
    transform: "translate(1031.25 491.28) rotate(180)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 487.69,
    y: 229.29,
    width: 1.36,
    height: 32.7,
    rx: 0.68,
    ry: 0.68,
    transform: "translate(976.75 491.28) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M480.88,178.87s.54-11.14,1.36-16.35c.82-5.21,2.04-7.49,2.73-10.9,.24-1.21,1.57-2.28,2.73-2.73,2.43-.93,5.51-1.48,10.9-1.36,1.33,.03,4.2-.89,5.45-1.36,3.08-1.16,9.63-3.41,16.35,2.73,0,0-1.54,4.29,0,8.18,1.54,3.89,2.73,4.46,2.73,6.81v14.99s9.89-18.86,0-35.43c0,0,1.04-5.31-5.45-8.18,0,0-1.51-5.21-9.54-4.09,0,0-8.18-3.41-13.63,1.36,0,0-8.86-2.04-10.9,6.81,0,0-5.45,1.36-5.45,8.18,0,0-5.45,2.73-1.36,10.9,0,0,0,13.63,4.09,20.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M455.12,277.34c-4.74,7.05-14.57,19.87-21.4,28.66h22.33c.21-2.6,1.04-15-.93-28.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M454.38,272.9c-.04-.23-.08-.45-.13-.68-.08,.13-.02,.37,.13,.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M454.25,272.22c.04,.23,.08,.45,.13,.68-.14-.3-.21-.55-.13-.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Screen"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 351.12,
    y: 144,
    width: 222.88,
    height: 139
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-45",
    points: "490.63 283 397.63 283 351.12 214.35 351.12 145.7 388.77 145.7 490.63 283"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "523.85 283 506.14 283 404.27 145.7 424.2 145.7 523.85 283"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M487.69,204.76h0v12.75c0,1.3-.92,2.42-2.19,2.67-.19,.04-.36,.08-.51,.12,6.66,7.81,17.01,15.8,17.01,15.8,0,0,10.37-8,17.02-15.82-.17-.03-.34-.07-.53-.1-1.27-.25-2.19-1.37-2.19-2.67v-12.75h0v-1.36h0v-1.36h-28.62v1.36h0v1.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M502.68,215.66h-14.99v-13.63h28.62c0,7.53-6.1,13.63-13.63,13.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M529.91,167.97c0-1.36-1.36-2.73-2.73-2.73h-1.59c.16-1.11,.25-2.25,.25-3.41,0-13.17-6.68-19.84-19.85-19.84s-27.85,6.67-27.85,19.84c0,1.16,.09,2.29,.25,3.41h-1.61c-1.36,0-2.73,1.36-2.73,2.72,0,0,.41,17.71,6.11,17.71l-1.75-20.29h0l2.46,28.47c0,4.09,9.54,10.9,9.54,10.9,0,0,4.8,5.45,11.58,5.45s11.58-5.45,11.58-5.45c0,0,9.54-6.81,9.54-10.9l.7-8.18c5.68-.03,6.09-17.71,6.09-17.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M526.04,150c-.68-2.19-1.63-4.4-2.92-6.56,0,0,.18-.97-.1-2.3h-42.4c-1.27,1.22-2.46,3.2-2.46,6.39,0,0-1.4,.71-2.25,2.47-.82,1.71-1.12,4.41,.89,8.43,0,0,0,13.63,4.09,20.44,0,0,.54-11.14,1.36-16.35,.82-5.21,2.04-7.49,2.73-10.9,.12-.59,.5-1.15,.99-1.62,.51-.49,1.15-.88,1.74-1.11,2.43-.93,5.51-1.48,10.9-1.36,1.33,.03,4.2-.89,5.45-1.36,3.08-1.16,9.63-3.41,16.35,2.73,0,0-.15,.42-.31,1.11-.35,1.53-.75,4.39,.31,7.07,1.54,3.89,2.73,4.46,2.73,6.81v14.99s7.47-14.26,2.92-28.87Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 351.12,
    y: 141.14,
    width: 222.88,
    height: 8.86
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 356.85,
    cy: 145.57,
    r: 1.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-37",
    cx: 362.8,
    cy: 145.57,
    rx: 1.5,
    ry: 1.55
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-37",
    cx: 368.74,
    cy: 145.57,
    r: 1.5
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M407.32,234.45l2.95-14.73v-9.3s-.39-10.85-.39-10.85l-.39-10.85c0-.86-.69-1.55-1.55-1.55s-1.55,.69-1.55,1.55l-.39,10.85-.39,10.85h-13.95s0,12.4,0,15.5,3.1,9.3,3.1,9.3h0c0,.62,.09,1.21,.26,1.78l3.71-.77,8.58-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M394.77,213.53s0,12.4,6.2,12.4c3.1-3.1,9.3-6.2,9.3-6.2,0,0,0-2.99,0-6.16,0-.93-2.32-3.61-4.54-6.24,0,0,.3,6.2-1.66,6.2h-9.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M405.6,210.15l-.95-4.57h0c-.12-1.01-1-1.76-2.03-1.7-1.07,.06-1.88,.98-1.82,2.05v.12s.01,0,.01,0l.04,.92-.18-1.49h0c-.14-.91-.92-1.62-1.87-1.64-1.07-.02-1.95,.83-1.97,1.89h0l-.2,1.94-.23-.76h0c-.27-.77-1-1.32-1.87-1.3-.93,.02-1.69,.69-1.86,1.57h0s-.76,2.27-.76,2.27c-.08,.17-.14,.34-.18,.53-.24,1.26,.58,2.48,1.84,2.72,.33,.06,.66,.05,.97-.02l1.31,3.26c.28,.81,1.17,1.23,1.97,.95,.46-.16,.79-.52,.94-.94l.15,.77c.13,.85,.93,1.42,1.77,1.29,.54-.08,.97-.44,1.17-.9l.04,.39c.05,.85,.79,1.5,1.64,1.45,.85-.05,1.5-.79,1.45-1.64l-.14-5.16c.55-.49,.86-1.23,.76-2.02Zm-7.48,2.55l.03,.17-.05-.18s.01,0,.02,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M411.82,222.83l-2.61-9.45-7.51-3.97c-1.72,4.15,3.25,6.59,3.25,6.59v1s-7.07,5.83-3.97,18.23h2.64l3.86-.8,4.35-11.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M405.33,215.77c-2.33-1.11-4.86-3.58-3.64-6.36-.67,1.23-.61,2.76,.11,3.98,.67,1.16,1.64,2.06,2.75,2.81v.66c-4.59,4.89-5.21,12.08-3.58,18.37-1.37-6.32-.49-13.47,4.36-18.07,0-.27,0-1.12,0-1.39Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M369.32,189.14c-2.11,0-3.82-1.71-3.82-3.82s1.71-3.82,3.82-3.82,3.82,1.71,3.82,3.82-1.71,3.82-3.82,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M369.32,182c1.83,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32-3.32-1.49-3.32-3.32,1.49-3.32,3.32-3.32m0-1c-2.38,0-4.32,1.94-4.32,4.32s1.94,4.32,4.32,4.32,4.32-1.94,4.32-4.32-1.94-4.32-4.32-4.32h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M369.32,188.31c-1.65,0-2.99-1.34-2.99-2.99s1.34-2.99,2.99-2.99,2.99,1.34,2.99,2.99-1.34,2.99-2.99,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M369.32,182.83c1.38,0,2.49,1.12,2.49,2.49s-1.12,2.49-2.49,2.49-2.49-1.12-2.49-2.49,1.12-2.49,2.49-2.49m0-1c-1.93,0-3.49,1.57-3.49,3.49s1.57,3.49,3.49,3.49,3.49-1.57,3.49-3.49-1.57-3.49-3.49-3.49h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 416,
    y1: 192,
    x2: 432,
    y2: 192
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M433,216.5c-.28,0-.5-.22-.5-.5v-1.11c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1.11c0,.28-.22,.5-.5,.5Zm0-3.32c-.28,0-.5-.22-.5-.5v-1.11c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1.11c0,.28-.22,.5-.5,.5Zm0-3.32c-.28,0-.5-.22-.5-.5v-1.11c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1.11c0,.28-.22,.5-.5,.5Zm0-3.32c-.28,0-.5-.22-.5-.5v-1.11c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1.11c0,.28-.22,.5-.5,.5Zm0-3.32c-.28,0-.5-.22-.5-.5v-1.11c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1.11c0,.28-.22,.5-.5,.5Zm0-3.32c-.28,0-.5-.22-.5-.5v-1.11c0-.28,.22-.5,.5-.5s.5,.22,.5,.5v1.11c0,.28-.22,.5-.5,.5Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 450.32,
    y1: 202.17,
    x2: 433.06,
    y2: 192.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 416,
    y1: 178,
    x2: 422,
    y2: 172
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 402,
    y1: 180,
    x2: 390,
    y2: 164
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-5",
    x1: 382,
    y1: 204,
    x2: 396,
    y2: 194
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M381.02,202.5c-.15,0-.3-.07-.4-.2l-.66-.89c-.17-.22-.12-.53,.1-.7,.22-.17,.53-.12,.7,.1l.66,.89c.17,.22,.12,.53-.1,.7-.09,.07-.2,.1-.3,.1Zm-1.99-2.66c-.15,0-.3-.07-.4-.2l-.66-.89c-.17-.22-.12-.53,.1-.7,.22-.17,.53-.12,.7,.1l.66,.89c.17,.22,.12,.53-.1,.7-.09,.07-.2,.1-.3,.1Zm-1.99-2.66c-.15,0-.3-.07-.4-.2l-.66-.89c-.17-.22-.12-.53,.1-.7,.22-.17,.53-.12,.7,.1l.66,.89c.17,.22,.12,.53-.1,.7-.09,.07-.2,.1-.3,.1Zm-1.99-2.66c-.15,0-.3-.07-.4-.2l-.66-.89c-.17-.22-.12-.53,.1-.7,.22-.17,.53-.12,.7,.1l.66,.89c.17,.22,.12,.53-.1,.7-.09,.07-.2,.1-.3,.1Zm-1.99-2.66c-.15,0-.3-.07-.4-.2l-.66-.89c-.17-.22-.12-.53,.1-.7,.22-.17,.53-.12,.7,.1l.66,.89c.17,.22,.12,.53-.1,.7-.09,.07-.2,.1-.3,.1Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 407.59,
    cy: 187.69,
    r: 7.75
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M433.06,195.94c-2.11,0-3.82-1.71-3.82-3.82s1.71-3.82,3.82-3.82,3.82,1.71,3.82,3.82-1.71,3.82-3.82,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M433.06,188.8c1.83,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32-3.32-1.49-3.32-3.32,1.49-3.32,3.32-3.32m0-1c-2.38,0-4.32,1.94-4.32,4.32s1.94,4.32,4.32,4.32,4.32-1.94,4.32-4.32-1.94-4.32-4.32-4.32h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M433.06,195.11c-1.65,0-2.99-1.34-2.99-2.99s1.34-2.99,2.99-2.99,2.99,1.34,2.99,2.99-1.34,2.99-2.99,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M433.06,189.63c1.38,0,2.49,1.12,2.49,2.49s-1.12,2.49-2.49,2.49-2.49-1.12-2.49-2.49,1.12-2.49,2.49-2.49m0-1c-1.93,0-3.49,1.57-3.49,3.49s1.57,3.49,3.49,3.49,3.49-1.57,3.49-3.49-1.57-3.49-3.49-3.49h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M449.67,205.99c-2.11,0-3.82-1.71-3.82-3.82s1.71-3.82,3.82-3.82,3.82,1.71,3.82,3.82-1.71,3.82-3.82,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M449.67,198.85c1.83,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32-3.32-1.49-3.32-3.32,1.49-3.32,3.32-3.32m0-1c-2.38,0-4.32,1.94-4.32,4.32s1.94,4.32,4.32,4.32,4.32-1.94,4.32-4.32-1.94-4.32-4.32-4.32h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M449.67,205.16c-1.65,0-2.99-1.34-2.99-2.99s1.34-2.99,2.99-2.99,2.99,1.34,2.99,2.99-1.34,2.99-2.99,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M449.67,199.68c1.38,0,2.49,1.12,2.49,2.49s-1.12,2.49-2.49,2.49-2.49-1.12-2.49-2.49,1.12-2.49,2.49-2.49m0-1c-1.93,0-3.49,1.57-3.49,3.49s1.57,3.49,3.49,3.49,3.49-1.57,3.49-3.49-1.57-3.49-3.49-3.49h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M424.68,172.5c-2.11,0-3.82-1.71-3.82-3.82s1.71-3.82,3.82-3.82,3.82,1.71,3.82,3.82-1.71,3.82-3.82,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M424.68,165.36c1.83,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32-3.32-1.49-3.32-3.32,1.49-3.32,3.32-3.32m0-1c-2.38,0-4.32,1.94-4.32,4.32s1.94,4.32,4.32,4.32,4.32-1.94,4.32-4.32-1.94-4.32-4.32-4.32h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M424.68,171.67c-1.65,0-2.99-1.34-2.99-2.99s1.34-2.99,2.99-2.99,2.99,1.34,2.99,2.99-1.34,2.99-2.99,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M424.68,166.19c1.38,0,2.49,1.12,2.49,2.49s-1.12,2.49-2.49,2.49-2.49-1.12-2.49-2.49,1.12-2.49,2.49-2.49m0-1c-1.93,0-3.49,1.57-3.49,3.49s1.57,3.49,3.49,3.49,3.49-1.57,3.49-3.49-1.57-3.49-3.49-3.49h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M389.32,166.5c-2.11,0-3.82-1.71-3.82-3.82s1.71-3.82,3.82-3.82,3.82,1.71,3.82,3.82-1.71,3.82-3.82,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M389.32,159.36c1.83,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32-3.32-1.49-3.32-3.32,1.49-3.32,3.32-3.32m0-1c-2.38,0-4.32,1.94-4.32,4.32s1.94,4.32,4.32,4.32,4.32-1.94,4.32-4.32-1.94-4.32-4.32-4.32h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M389.32,165.67c-1.65,0-2.99-1.34-2.99-2.99s1.34-2.99,2.99-2.99,2.99,1.34,2.99,2.99-1.34,2.99-2.99,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M389.32,160.19c1.38,0,2.49,1.12,2.49,2.49s-1.12,2.49-2.49,2.49-2.49-1.12-2.49-2.49,1.12-2.49,2.49-2.49m0-1c-1.93,0-3.49,1.57-3.49,3.49s1.57,3.49,3.49,3.49,3.49-1.57,3.49-3.49-1.57-3.49-3.49-3.49h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M382.68,207.14c-2.11,0-3.82-1.71-3.82-3.82s1.71-3.82,3.82-3.82,3.82,1.71,3.82,3.82-1.71,3.82-3.82,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M382.68,200c1.83,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32-3.32-1.49-3.32-3.32,1.49-3.32,3.32-3.32m0-1c-2.38,0-4.32,1.94-4.32,4.32s1.94,4.32,4.32,4.32,4.32-1.94,4.32-4.32-1.94-4.32-4.32-4.32h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M382.68,206.31c-1.65,0-2.99-1.34-2.99-2.99s1.34-2.99,2.99-2.99,2.99,1.34,2.99,2.99-1.34,2.99-2.99,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M382.68,200.83c1.38,0,2.49,1.12,2.49,2.49s-1.12,2.49-2.49,2.49-2.49-1.12-2.49-2.49,1.12-2.49,2.49-2.49m0-1c-1.93,0-3.49,1.57-3.49,3.49s1.57,3.49,3.49,3.49,3.49-1.57,3.49-3.49-1.57-3.49-3.49-3.49h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M433.32,222.5c-2.11,0-3.82-1.71-3.82-3.82s1.71-3.82,3.82-3.82,3.82,1.71,3.82,3.82-1.71,3.82-3.82,3.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M433.32,215.36c1.83,0,3.32,1.49,3.32,3.32s-1.49,3.32-3.32,3.32-3.32-1.49-3.32-3.32,1.49-3.32,3.32-3.32m0-1c-2.38,0-4.32,1.94-4.32,4.32s1.94,4.32,4.32,4.32,4.32-1.94,4.32-4.32-1.94-4.32-4.32-4.32h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M433.32,221.67c-1.65,0-2.99-1.34-2.99-2.99s1.34-2.99,2.99-2.99,2.99,1.34,2.99,2.99-1.34,2.99-2.99,2.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M433.32,216.19c1.38,0,2.49,1.12,2.49,2.49s-1.12,2.49-2.49,2.49-2.49-1.12-2.49-2.49,1.12-2.49,2.49-2.49m0-1c-1.93,0-3.49,1.57-3.49,3.49s1.57,3.49,3.49,3.49,3.49-1.57,3.49-3.49-1.57-3.49-3.49-3.49h0Z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-15",
    cx: 407.59,
    cy: 187.69,
    r: 4.43
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 407.59,
    cy: 187.69,
    r: 7.75
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M411.5,198.06c-1.22,.46-2.53,.71-3.91,.71-6.12,0-11.07-4.96-11.07-11.07"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M407.59,176.62c1.38,0,2.69,.25,3.91,.71,4.19,1.58,7.16,5.62,7.16,10.36"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Overlapping"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 475,
    cy: 89,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 475,
    cy: 89,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 285,
    cy: 145,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 285,
    cy: 145,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 195,
    cy: 68.58,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 195,
    cy: 68.58,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 183,
    cy: 269,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 183,
    cy: 269,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 63,
    cy: 233,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 63,
    cy: 233,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-34",
    cx: 377,
    cy: 71,
    r: 5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 377,
    cy: 71,
    r: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M320.57,92.07c-.15-.75-.38-1.48-.68-2.18-.88-2.08-2.35-3.85-4.2-5.1-.31-.21-.63-.4-.96-.58-1.64-.89-3.52-1.4-5.53-1.4-.36,0-.72,.02-1.07,.05-.1,0-.21,.02-.31,.04-.26,.03-.51,.07-.77,.12-.1,.02-.2,.04-.3,.06-.22,.05-.43,.11-.64,.17-1.62-5.91-6.16-10.62-11.99-12.43-1.69-.53-3.49-.81-5.35-.81-.59,0-1.17,.03-1.75,.09-.2,.02-.4,.06-.59,.08-.37,.05-.74,.1-1.11,.17-.23,.05-.46,.11-.69,.16-.32,.08-.64,.15-.95,.24-.24,.07-.48,.15-.71,.23-.18,.06-.36,.11-.53,.17-.13,.05-.26,.11-.38,.16-.18,.07-.36,.15-.53,.22-.34,.15-.67,.31-1,.48-.14,.07-.29,.14-.43,.22-.45,.25-.89,.51-1.31,.8-.11,.07-.21,.15-.32,.23-.32,.23-.64,.46-.95,.71-.14,.12-.28,.24-.42,.36-.27,.23-.53,.47-.79,.72-.13,.12-.25,.24-.38,.37-.32,.33-.63,.67-.93,1.02-.04,.05-.08,.09-.12,.13-.33,.4-.63,.82-.93,1.24-.09,.13-.18,.27-.27,.41-.2,.31-.39,.63-.58,.95-.09,.16-.17,.31-.26,.47-.14,.27-.27,.54-.4,.81-.18,0-.37,.02-.55,.03-.12,.01-.24,.03-.36,.04-.26,.03-.51,.07-.77,.12-.13,.02-.26,.05-.38,.08-.27,.06-.53,.13-.78,.2-.1,.03-.19,.05-.29,.08-.02,0-.04,0-.05,.02-.33,.1-.65,.22-.96,.36-.1,.04-.19,.09-.29,.13-.24,.11-.47,.22-.7,.34-.12,.06-.24,.13-.36,.2-.2,.11-.4,.23-.59,.36-.12,.08-.23,.15-.34,.23-.2,.14-.4,.29-.6,.45-.09,.07-.18,.14-.27,.21-.27,.23-.53,.47-.79,.71-.06,.06-.11,.12-.17,.18-.19,.2-.38,.4-.56,.62-.08,.1-.16,.2-.24,.3-.15,.19-.29,.38-.43,.57-.08,.11-.15,.22-.22,.33-.14,.21-.27,.43-.39,.65-.06,.1-.11,.19-.17,.29-.17,.32-.33,.64-.47,.98-.02,.04-.03,.09-.05,.13-.12,.3-.23,.6-.33,.9-.04,.12-.07,.23-.1,.35-.07,.24-.13,.49-.19,.74-.03,.13-.06,.26-.08,.39-.05,.26-.09,.52-.12,.78-.01,.12-.03,.24-.04,.36-.02,.23-.03,.47-.04,.7-.19,0-.39,.01-.57,.03-.12,.01-.24,.03-.36,.05-.09,.01-.18,.02-.27,.04,0,0-.01,0-.02,0-.36,.07-.71,.17-1.05,.3-.04,.02-.09,.03-.13,.05-.33,.13-.64,.28-.94,.46-.04,.03-.09,.05-.13,.08-.3,.18-.59,.39-.86,.61-.02,.02-.05,.04-.07,.06-.27,.23-.52,.49-.75,.76,0,0-.02,.02-.02,.03-.23,.27-.43,.56-.61,.87-.03,.04-.05,.09-.08,.13-.17,.3-.31,.61-.44,.93-.02,.06-.04,.12-.06,.17-.12,.33-.21,.66-.28,1.01,0,.05-.01,.1-.02,.15-.06,.37-.1,.74-.1,1.13,0,1.42,.43,2.74,1.17,3.84,.25,.37,.53,.71,.84,1.02s.65,.59,1.02,.84c.37,.25,.76,.46,1.17,.63,.79,.33,1.65,.52,2.56,.53h0s49.2-.02,49.2-.02c4.18-.34,6.03-2.15,6.04-2.15,.19-.14,.38-.29,.57-.44,.04-.03,.55-.48,.76-.69,.04-.04,.09-.08,.13-.13,.22-.22,.43-.46,.64-.7,.05-.06,.09-.11,.14-.17,.2-.25,.4-.51,.58-.77,.02-.03,.04-.06,.06-.09,.17-.25,.33-.51,.47-.78,.03-.05,.06-.11,.09-.16,.15-.28,.29-.57,.42-.87,.03-.06,.05-.13,.08-.19,.13-.31,.24-.62,.34-.94,0-.02,0-.04,.02-.05,.1-.31,.18-.63,.24-.95,.01-.06,.03-.13,.04-.19,.06-.33,.12-.66,.15-1,0-.07,.01-.13,.02-.2,.03-.35,.05-.71,.05-1.07,0-.8-.08-1.58-.24-2.34Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17-2",
    "data-name": "Group-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-2",
    "data-name": "Combined-Shape",
    className: "cls-24",
    d: "M289.66,82.96c1.96,0,3.56,1.58,3.56,3.53,0,1.33-.74,2.49-1.84,3.09l.51,4.57c.02,.18-.11,.33-.29,.35h-.02s-3.82,0-3.82,0c-.18,0-.32-.14-.32-.32,0-.01,0-.02,0-.04l.51-4.57c-1.1-.6-1.84-1.76-1.84-3.09,0-1.95,1.59-3.53,3.56-3.53Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M127.33,179.38c-.24-1.17-.59-2.3-1.05-3.38-1.37-3.23-3.65-5.98-6.52-7.92-.48-.32-.97-.62-1.48-.9-2.55-1.38-5.47-2.17-8.58-2.17-.56,0-1.11,.03-1.66,.08-.16,.01-.32,.04-.48,.06-.4,.05-.8,.11-1.19,.18-.16,.03-.31,.06-.47,.09-.33,.07-.65,.16-.97,.25-.08-.31-.17-.62-.26-.92-.27-.87-.59-1.73-.94-2.57-.53-1.25-1.15-2.46-1.85-3.61-.93-1.54-2.01-2.97-3.21-4.3-.9-.99-1.87-1.92-2.91-2.77-.69-.57-1.41-1.11-2.15-1.61-.74-.5-1.51-.97-2.3-1.4s-1.61-.82-2.44-1.18c-3.34-1.41-7.02-2.2-10.87-2.2-.46,0-.91,.01-1.37,.03-.16,0-.31,.02-.47,.03-.29,.02-.58,.04-.88,.07-.19,.02-.38,.04-.57,.06-.25,.03-.51,.06-.76,.1-.2,.03-.41,.06-.61,.1-.23,.04-.46,.08-.69,.12-.21,.04-.42,.09-.63,.13-.22,.05-.43,.1-.64,.15-.22,.05-.44,.11-.65,.17-.2,.05-.4,.11-.6,.17-.22,.07-.44,.13-.66,.2-.19,.06-.37,.12-.56,.19-.23,.08-.45,.15-.67,.24-.03,0-.05,.02-.08,.03-.04,.02-.08,.04-.13,.05-.56,.22-1.12,.45-1.66,.7-.08,.04-.16,.07-.24,.11-.58,.27-1.14,.56-1.7,.87-.08,.05-.16,.09-.24,.14-.52,.3-1.03,.61-1.52,.93-.05,.03-.1,.06-.15,.09-.53,.35-1.04,.72-1.54,1.11-.09,.07-.17,.14-.26,.2-.49,.39-.97,.78-1.43,1.2,0,0-.02,.01-.02,.02-.47,.42-.92,.87-1.36,1.32-.08,.09-.17,.17-.25,.26-.43,.46-.85,.93-1.25,1.42,0,0,0,0,0,.01-.39,.48-.77,.98-1.13,1.48-.07,.1-.15,.2-.22,.31-.35,.51-.69,1.03-1.01,1.56-.04,.07-.08,.13-.11,.2-.29,.49-.56,.98-.82,1.49-.06,.11-.11,.22-.17,.33-.1,.21-.21,.43-.3,.64-.28,.01-.56,.03-.84,.05-.19,.02-.37,.04-.55,.07-.4,.05-.8,.11-1.2,.18-.2,.04-.39,.07-.59,.12-.41,.09-.82,.2-1.22,.31-.15,.04-.3,.08-.44,.12-.03,0-.06,.02-.09,.02-.51,.16-1,.35-1.49,.55-.15,.06-.3,.14-.45,.21-.37,.17-.73,.34-1.09,.52-.19,.1-.37,.21-.56,.31-.31,.18-.62,.36-.92,.56-.18,.12-.36,.23-.53,.35-.32,.22-.62,.45-.93,.69-.14,.11-.28,.21-.41,.32-.42,.35-.83,.72-1.22,1.11-.09,.09-.17,.19-.26,.28-.3,.31-.59,.63-.87,.96-.13,.15-.25,.31-.37,.47-.23,.29-.45,.59-.67,.89-.12,.17-.24,.34-.35,.51-.21,.33-.41,.66-.61,1-.09,.15-.18,.3-.26,.45-.26,.5-.51,1-.73,1.52-.03,.07-.05,.14-.08,.21-.19,.46-.36,.93-.51,1.4-.06,.18-.11,.36-.16,.55-.11,.38-.21,.76-.29,1.15-.04,.2-.09,.4-.12,.61-.08,.4-.13,.8-.18,1.21-.02,.18-.05,.37-.07,.55-.03,.36-.05,.73-.06,1.09-.3,0-.6,.02-.89,.05-.19,.02-.37,.05-.56,.08-.14,.02-.27,.03-.41,.06-.01,0-.03,0-.04,0-.17,.03-.33,.08-.49,.12-.16,.04-.32,.08-.47,.12-.16,.05-.32,.1-.48,.16-.15,.05-.3,.1-.45,.16-.16,.06-.31,.13-.46,.2-.14,.07-.29,.13-.43,.21-.15,.08-.29,.15-.44,.23-.14,.08-.28,.16-.41,.25-.14,.09-.27,.17-.4,.26-.14,.1-.27,.2-.4,.3-.12,.09-.24,.18-.36,.28-.15,.12-.29,.26-.42,.39-.09,.09-.19,.17-.28,.26-.22,.22-.43,.45-.63,.69-.07,.09-.14,.19-.21,.28-.13,.16-.25,.33-.37,.5-.08,.11-.14,.22-.22,.34-.1,.16-.2,.32-.3,.49-.07,.12-.13,.24-.19,.37-.09,.17-.17,.34-.25,.51-.06,.13-.11,.25-.16,.38-.07,.18-.14,.36-.2,.54-.04,.13-.09,.26-.13,.39-.06,.19-.1,.39-.15,.59-.03,.13-.06,.25-.09,.38-.04,.22-.07,.45-.1,.67-.01,.11-.03,.22-.04,.33-.03,.34-.05,.68-.05,1.03,0,5.82,4.67,10.55,10.47,10.64h0s.18,0,.18,0H110.83v-.05c3.49-.22,6.71-1.42,9.38-3.34-.01,0-.03,0-.04,.01h0s.03,0,.04-.01c.3-.22,.6-.45,.88-.68,.06-.05,.12-.1,.18-.15,.35-.29,.69-.6,1.01-.92,.07-.07,.14-.13,.21-.2,.35-.35,.67-.71,.99-1.09,.07-.09,.15-.18,.22-.27,.31-.39,.62-.79,.9-1.2,.03-.05,.06-.1,.09-.14,.26-.39,.51-.8,.74-1.21,.05-.09,.1-.17,.14-.26,.24-.44,.45-.89,.65-1.35,.04-.1,.08-.2,.12-.3,.2-.48,.38-.96,.54-1.46,0-.03,.02-.06,.02-.08,.15-.48,.27-.98,.38-1.48,.02-.1,.04-.2,.06-.29,.1-.51,.18-1.02,.24-1.55,.01-.1,.02-.21,.03-.31,.05-.55,.08-1.1,.08-1.65,0-1.24-.13-2.46-.37-3.63Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-17-3",
    "data-name": "Group-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape-3",
    "data-name": "Combined-Shape",
    className: "cls-24",
    d: "M79.35,165.24c3.05,0,5.52,2.45,5.52,5.48,0,2.07-1.16,3.87-2.86,4.8l.79,7.09c.03,.27-.17,.52-.44,.55h-.03s-5.93,0-5.93,0c-.28,0-.5-.22-.5-.5,0-.02,0-.04,0-.05l.79-7.09c-1.71-.93-2.86-2.73-2.86-4.8,0-3.02,2.47-5.48,5.52-5.48Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M149.57,197.82c-.69,0-1.35,.09-1.99,.25,.16-1,.25-2.02,.25-3.07,0-10.49-8.62-19-19.26-19s-18.4,7.69-19.19,17.47c-.1,0-.19-.01-.29-.01-4.69,0-8.65,3.05-9.95,7.26-.13,0-.26-.02-.4-.02-3.72,0-6.74,2.98-6.74,6.65s3.02,6.65,6.74,6.65c.02,0,.05,0,.07,0h0s50.75,0,50.75,0h0s0,0,0,0c4.53,0,8.2-3.62,8.2-8.09s-3.67-8.09-8.2-8.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M333.74,109.65c-.53,0-1.03,.07-1.52,.19,.13-.76,.19-1.54,.19-2.34,0-8.01-6.58-14.5-14.7-14.5s-14.04,5.87-14.65,13.34c-.07,0-.15-.01-.22-.01-3.58,0-6.6,2.33-7.59,5.54-.1,0-.2-.02-.3-.02-2.84,0-5.15,2.27-5.15,5.08s2.3,5.08,5.15,5.08c.02,0,.03,0,.05,0h0s38.73,0,38.73,0h0s0,0,0,0c3.46,0,6.26-2.76,6.26-6.17s-2.8-6.17-6.26-6.17Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardHero);
export default __webpack_public_path__ + "static/media/dashboard_hero.6e9cc80991276f612de7f4a47c4af089.svg";
export { ForwardRef as ReactComponent };